export function faqPageItemSection(componentContent) {
  return {
    q: componentContent.title,
    a: componentContent.content
  };
}